export function setToken(state, token) {
  state.token = token;
}
